module.exports = __webpack_public_path__ + "static/media/sidebar-1.8e9f0a3c.jpg";